import { Component, EventEmitter, Input, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'caremoni-multi-select-box',
  templateUrl: './multi-select-box.component.html',
  styleUrl: './multi-select-box.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class MultiSelectBoxComponent {
  @Input() isTVmode: boolean = false;
  @Input() options: any[] = [];
  @Input() selectedValues: any[] = [];
  @Input() id: string = 'multi-select-box';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<any>();

  @Input() xdpad?: number = -1;
  @Input() ydpad?: number = -1;
  @Input() dpad?: number = -1;
  @Input() tabdpad?: number = -1;
  @Input() xtabdpad?: number = -1;
  @Input() ytabdpad?: number = -1;
  @Input() scaledpad?: number = -1;

  isReset = false;
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isTVmode) return;

    if (changes['options'] && changes['options'].currentValue) {

      this.isReset = false;
      const vlSelected = cloneDeep(this.selectedValues);

      if (this.id === 'group-multi-select') {
        this.selectedValues = vlSelected;
        this.isReset = true;

        setTimeout(() => {
          this.isReset = false;
        }, 100);
      }
    }
  }

  onChangeValue(values: any[]): void {
    this.valueChange.emit(values);
  }

  onChangeValueTV(values: any[]): void {
    this.valueChange.emit(values);
  }

  removeHiddenInputs() {
    const hiddenInputs = document.querySelectorAll('.p-multiselect .p-hidden-accessible input');
    hiddenInputs.forEach(el => el.remove());
  }
}
